import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCostControl = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cost-control';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.84 4.283c-.985.105-1.921.72-2.316 1.521-.299.606-.283.226-.283 6.696l-.001 5.801.73.729.731.73h14.6l.729-.73.73-.731v-9.6l-.73-.729-.731-.73H17.76V5.699l-.73-.729-.731-.73-5.079.005c-2.794.003-5.215.02-5.38.038m10.129 1.746.271.269v.942H4.76v-.278c0-.153.022-.329.048-.39.138-.32.482-.6.902-.734.218-.07.49-.074 5.109-.076l4.879-.002zm3 3 .271.269v8.4l-.269.271-.269.271h-13.4l-.271-.269-.271-.269V8.76h13.938zm-2.692 3.253c-.776.126-1.241 1.005-.91 1.721a1.24 1.24 0 0 0 2.266 0c.08-.172.104-.287.104-.503 0-.775-.684-1.345-1.46-1.218"
    })
  }));
});
export default SvgCostControl;